import React, { Fragment } from "react";
import styled from "styled-components";
import { DialogContent, Dialog, Grid, Typography } from "@mui/material";

import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../../css components/Button";

const Card = styled(Dialog)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export default function LockMyCampaignDialog({
  dialog,
  setDialog,
  handleLockCampaign,
  lockCampaignLoading,
}) {
  const handleClose = () => {
    setDialog(false);
  };

  return (
    <Card
      open={dialog.state}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "fit-content !important",
        },
      }}
    >
      <DialogContent>
        <Grid container spacing={3} style={{ padding: "20px" }}>
          <Grid size={12} marginBottom={"10px"}>
            <Typography variant="h4">
              Are you sure you want to {dialog.heading}
            </Typography>
          </Grid>

          <Fragment>
            <Grid size="auto" offset={{ xs: "auto" }} />

            <Grid size="auto">
              <CancelButton onClick={() => handleClose()} variant="outlined">
                Cancel
              </CancelButton>
            </Grid>

            <Grid size="auto">
              <PrimaryLoadingButton
                onClick={() => dialog.func()}
                variant="contained"
                loading={lockCampaignLoading}
              >
                Confirm
              </PrimaryLoadingButton>
            </Grid>
          </Fragment>
        </Grid>
      </DialogContent>
    </Card>
  );
}
